export default "__VITE_ASSET__C0480GRX__"